<template>
<v-dialog v-model="displayDialog" transition="dialog-bottom-transition" max-width="500px" persistent>
    <v-card>
        <v-card-title class="headline">Add Budget Value</v-card-title>
        <v-card-text>
            <v-form ref="form" v-model="formValid">
                <v-layout column>
                    <v-flex xs12>
                        <v-autocomplete ref="week" 
                            :value="budgetValue.WeekNumber" 
                            @input="updateWeek" 
                            :items="availableWeeks" 
                            label="Week" 
                            clearable 
                            :rules="[rules.requiredObject]">
                        </v-autocomplete>
                    </v-flex>
                    <v-flex>
                        <v-text-field
                            :value="budgetValue.BudgetValue"
                            @input="updateBudgetValue"
                            type="number"
                            label="Budget Value (%)"
                            :rules="[rules.requiredNumber, validateBudgetValue]"
                            clearable>
                        </v-text-field>
                    </v-flex>                
                </v-layout>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" :disabled="!formValid" @click="save()">Add</v-btn>
            <v-btn color="secondary" @click="cancel()">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>

</template>

<script>
import validationRules from "@/helpers/validationrules";

export default {
    props: {
        displayDialog: {
            type: Boolean,
            required: true
        },
        availableWeeks: {
            type: Array,
            required: true
        },
    },
    data() {
        return {            
            rules: validationRules.rules,
            formValid: true,
            budgetValue: {}
        }
    },
    methods: {
        validateBudgetValue(v) {
            if (v !== null && v !== undefined && !v.match(/^(\d{0,2}(\.\d{1})?|100(\.0?)?)$/)) {
                return "Please enter a number between 1 and 100";
            }

            return false;
        },
        updateWeek(v) {            
            this.budgetValue.WeekNumber = v;
        },
        updateBudgetValue(v) {
            this.budgetValue.BudgetValue = v;
        },
        save() {
            this.$emit('save', {
                WeekNumber: this.budgetValue.WeekNumber,
                BudgetValue: this.budgetValue.BudgetValue
            });

            this.budgetValue = {};
            this.$refs.form.reset();
        },
        cancel() {
            this.$emit('cancel');
            this.budgetValue = {};
            this.$refs.form.reset();
        }
    }
}
</script>
